const SERVER = import.meta.env.VITE_API_URL;
import axios from "../../configs/axios.config";

const createNewVendor = async (formdata) => {
  // console.log("Adding vendor with data:", ...formdata.entries());
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.post(`${SERVER}/inventory/newVendor`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data?.data;
  } catch (error) {
    console.error(
      "Error fetching roles:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to fetch roles");
  }
};

const addVendor = async (formdata) => {
  // console.log("Adding vendor with data:", formdata);
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.post(`${SERVER}/inventory/addVendor`, formdata, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data?.data;
  } catch (error) {
    console.error(
      "Error adding vendor:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to add vendor");
  }
};

const getVendorsList = async (page, limit, query, statusFilter) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    const safePage = Math.max(1, Number(page));
    const safeLimit = Math.max(1, Number(limit));
    const q = query ? `&query=${encodeURIComponent(query)}` : "";
    const s = statusFilter ? `&status=${encodeURIComponent(statusFilter)}` : "";

    let response = await axios.get(
      `${SERVER}/inventory/vendors?page=${safePage}&limit=${safeLimit}${q}${s}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 401 || error.response?.status === 403) {
      throw new Error("Unauthorized user");
    }
    console.error(
      "Error fetching vendors:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to fetch vendors");
  }
};
const getVendorDetails = async (id) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.get(`${SERVER}/inventory/vendor/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching vendors details:",
      error.response?.data?.message || error.message,
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch vendors details",
    );
  }
};

const updateVendorDetails = async (id, formdata) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.patch(
      `${SERVER}/inventory/vendor/${id}`,
      formdata,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      },
    );

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching roles:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to fetch roles");
  }
};

const deleteVendor = async (id) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.delete(`${SERVER}/inventory/vendor/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error deleting vendor:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to delete vendor");
  }
};

const getVendorFleets = async (vendorId) => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) throw new Error("Token not found");
    const response = await axios.get(`${SERVER}/inventory/vendor/${vendorId}/fleets`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch vendor fleets");
  }
};

const getVendorDrivers = async (vendorId) => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) throw new Error("Token not found");
    const response = await axios.get(`${SERVER}/inventory/vendor/${vendorId}/drivers`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch vendor drivers");
  }
};

const getVendorTrips = async (vendorId) => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) throw new Error("Token not found");
    const response = await axios.get(`${SERVER}/inventory/vendor/${vendorId}/trips`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch vendor trips");
  }
};

const getVendorAuditLogs = async (vendorId, page = 1, limit = 50) => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) throw new Error("Token not found");
    const response = await axios.get(`${SERVER}/inventory/vendor/${vendorId}/audit-logs?page=${page}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch vendor audit logs");
  }
};

export {
  createNewVendor,
  getVendorsList,
  getVendorDetails,
  updateVendorDetails,
  addVendor,
  deleteVendor,
  getVendorFleets,
  getVendorDrivers,
  getVendorTrips,
  getVendorAuditLogs,
};
